import React, { useState, useEffect, useContext } from "react";
import "../styles/style.css"
import { api_domain } from "../config"
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";

export function About() {
  const [summary, setSummary] = useState(null);
  const { basicHttpAuthString } = useContext(AuthContext);

  useEffect(() => {
    fetch(`${api_domain}/report/overall`, {
      headers: {
        Authorization: `${basicHttpAuthString}`
      }
    })
      .then((response) => response.json())
      .then((data) => setSummary(data));
  }, [])

  return (

    <div className="container">
    <Menu/>
    {/*<script>{menuFunction()}</script>*/}
    <div className="tools">
        <div className="titleMain">About the Public Interest Ad Archive</div>
        <div className="txt">
                  Online advertisements are an unavoidable fact of the modern web -- they are embedded in and financially support the majority of content websites. As such, the content in these ads makes up a significant fraction of the information that people encounter as they browse the web. Depending on the ad, the content can range from useful (e.g., ads for products a user truly wants to buy) to annoying (e.g., poorly designed product ads) to deceptive (e.g., misleading clickbait headlines that look like real news headlines) to downright dangerous (e.g., scams). <b> Despite its wide reach, the online ad ecosystem is opaque.</b> Different people may see vastly different online ads, and many different ad networks and other intermediaries are involved in the creation, placement, and delivery of ads. <b>This lack of transparency makes it hard to publicly detect, audit, or analyze potentially problematic ad content.</b>
                  <p><b>The Public Interest Ad Archive Project aims to provide transparency to the online advertising ecosystem.</b> With this archive, we aim to collect and make available to researchers, journalists, and the public information about ads appearing on different sites over time, allowing investigations into specific advertisers or ad campaigns or ad networks, the potentially harmful impacts of particular types of ads, longitudinal studies or deep dives into the ad ecosystem around sensitive current events, etc. </p>
                  <p>This project builds on our research group’s prior expertise and experience in studying online ads: <a className="txta" href="https://ads.cs.washington.edu/" >https://ads.cs.washington.edu.</a></p>
                  <h1><br></br>Contributors</h1>
                  <h2><a className="txta" href="https://www.franziroesner.com" >Franziska Roesner </a>(Associate Professor, PI)</h2>
	  	  <h2><a className="txta" href="https://www.linkedin.com/in/vadym-denysenko-95aa52208/" >Vadym Denysenko </a>(Allen School BS student)</h2>
                  <h2><a className="txta" href="https://www.linkedin.com/in/otari-ioseliani-064b5186/" >Otari Ioseliani </a>(Software Engineer)</h2>
                  <h2><a className="txta" href="https://umariqbal.com/" >Umar Iqbal </a>(Allen School postdoc alum)</h2>
                  <h2><a className="txta" href="https://www.linkedin.com/in/manasi-shah-a92827189/" >Manasi Shah </a>(Allen School BS alum)</h2>
                  <h2><a className="txta" href="https://homes.cs.washington.edu/~mxo/" >Maia Xiao </a>(Allen School BS/MS alum)</h2>
                  <h2><a className="txta" href="https://www.ericwzeng.com/" >Eric Zeng </a>(Allen School PhD alum)</h2>
<h1><br></br>Funding</h1>
<p>This project is supported in part by a <a className="txta" href="https://innovation.consumerreports.org/initiatives/the-bad-ads-project/" >Consumer Reports Digital Lab Fellowship</a>, by the National Science Foundation under <a className="txta" href="https://www.nsf.gov/awardsearch/showAward?AWD_ID=2041894" >Award #2041894</a>, and by the University of Washington Center for an Informed Public and the John S. and James L. Knight Foundation.</p><br></br>
  
  { 
   <div id="footer">
   <div id="seclb"><img src= {require('../files/seclab.jpeg')}/></div>
   <div id="allsc"><img src= {require('../files/allen_school.jpeg')}/></div>
   <div id="allsc"><img src= {require('../files/consumer_report.jpeg')}/></div>
   <div id="allsc"><img src= {require('../files/uw_cip.jpeg')}/></div>
   </div>
  }
   </div>
   </div>

   </div>
  );
}
